<template>
  <div
      class="home page-template-default page page-id-12105 wp-custom-logo header-horizontal site-layout-full elementor-default elementor-kit-12104 elementor-page elementor-page-12105">
    <div class="whole-layout">

      <main-header :tag-index="1"></main-header>

      <div id="mid"
           class="to-move no-top-space no-bottom-space layout-center layout-parted layout-no-edge layout-fixed no-sidebars">
        <article id="content" class="clearfix" itemtype="https://schema.org/CreativeWork" itemscope="">
          <div class="content-limiter" style="width: 100%">
            <div id="col-mask">

              <div id="post-12105" class="content-box post-12105 page type-page status-publish">
                <div class="formatter" style="padding: 0">
                  <div class="real-content" itemprop="text">
                    <div data-elementor-type="wp-post" data-elementor-id="12105"
                         class="elementor elementor-12105" data-elementor-settings="[]">
                      <div class="elementor-section-wrap">
                        <div style="display: flex; align-items: center; justify-content: center">
                          <section
                              style="max-width: 1200px;"
                              id="section-1"
                              class="elementor-section elementor-top-section elementor-element elementor-element-79507e37 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="79507e37" data-element_type="section"
                              data-settings='{"stretch_section":"section-stretched"}'>
                            <div class="elementor-container elementor-column-gap-no">
                              <div
                                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-25c5f6c0"
                                  data-id="25c5f6c0" data-element_type="column">
                                <div class="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      class="elementor-element elementor-element-5800792 elementor-widget elementor-widget-spacer"
                                      data-id="5800792" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-45e9d193 elementor-widget elementor-widget-heading"
                                      data-id="45e9d193" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2
                                          class="elementor-heading-title elementor-size-default">
                                        xiaomo hufu</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-46ddab4c elementor-widget elementor-widget-heading"
                                      data-id="46ddab4c" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2
                                          class="elementor-heading-title elementor-size-default">
                                        小茉护肤</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2a4286dd elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2a4286dd" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-cadad04 elementor-widget elementor-widget-text-editor"
                                      data-id="cadad04" data-element_type="widget"
                                      data-widget_type="text-editor.default">
                                    <div class="elementor-widget-container">
                                      <p>小茉护肤App，致力于科学护肤理念，通过专业肤质测试，为您量身定制个性化护肤方案。</p>
                                      <p>
                                        我们的产品系列，从洁面到面霜，每一款都经过医肤师的严格挑选与配方设计，确保安全有效。</p>
                                      <p>
                                        在小茉，您不仅能享受到高品质护肤产品，还将获得医肤师的专业指导，帮助您深入了解自己的肌肤，</p>
                                      <p>掌握正确的护肤方法。选择小茉，开启您的个性化科学护肤之旅，让肌肤焕发健康之美。 </p>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2f953eb elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2f953eb" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-93748cf elementor-widget elementor-widget-spacer"
                                      data-id="93748cf" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <div class="pic-box">
                            <img class="pic-img" src="@/assets/images/pic-applet.jpg" alt>
                          </div>
                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; background: #035940;">
                          <div class="pic-box">
                            <img class="pic-img" src="@/assets/images/pic-applet.jpg" alt>
                          </div>
                          <section
                              style="max-width: 1200px;"
                              id="section-1"
                              class="elementor-section elementor-top-section elementor-element elementor-element-79507e37 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="79507e37" data-element_type="section"
                              data-settings='{"stretch_section":"section-stretched"}' >
                            <div class="elementor-container elementor-column-gap-no">
                              <div
                                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-25c5f6c0"
                                  data-id="25c5f6c0" data-element_type="column">
                                <div class="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      class="elementor-element elementor-element-5800792 elementor-widget elementor-widget-spacer"
                                      data-id="5800792" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-45e9d193 elementor-widget elementor-widget-heading"
                                      data-id="45e9d193" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2 style="color: rgba(240,240,240,0.4)"
                                          class="elementor-heading-title elementor-size-default">
                                        hufu quanshu</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-46ddab4c elementor-widget elementor-widget-heading"
                                      data-id="46ddab4c" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2 style="color: #fff"
                                          class="elementor-heading-title elementor-size-default">
                                        护肤全书</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2a4286dd elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2a4286dd" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-cadad04 elementor-widget elementor-widget-text-editor"
                                      data-id="cadad04" data-element_type="widget"
                                      data-widget_type="text-editor.default">
                                    <div class="elementor-widget-container" style="color: #fff">
                                      <p>护肤全书，您的日常护肤小工具。每天一个护肤小知识，帮您轻松把握日常护理的精髓。</p>
                                      <p>
                                        通过皮肤状态记录工具，细致记录肌肤的每一次微妙变化，为您提供肌肤健康状态监测与分析。</p>
                                      <p>
                                        应用还提供专业的肤质检测和智能皮肤分析，深入洞察肌肤的水分、油脂等关键健康指标。</p>
                                      <p>通过护肤全书，获得个性化的护肤建议，打造适合自己肌肤的护理方案，让科学护肤触手可及。 </p>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2f953eb elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2f953eb" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-93748cf elementor-widget elementor-widget-spacer"
                                      data-id="93748cf" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div style="display: flex; align-items: center; justify-content: center">
                          <section
                              style="max-width: 1200px;"
                              id="section-1"
                              class="elementor-section elementor-top-section elementor-element elementor-element-79507e37 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="79507e37" data-element_type="section"
                              data-settings='{"stretch_section":"section-stretched"}'>
                            <div class="elementor-container elementor-column-gap-no">
                              <div
                                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-25c5f6c0"
                                  data-id="25c5f6c0" data-element_type="column">
                                <div class="elementor-widget-wrap elementor-element-populated">
                                  <div
                                      class="elementor-element elementor-element-5800792 elementor-widget elementor-widget-spacer"
                                      data-id="5800792" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-45e9d193 elementor-widget elementor-widget-heading"
                                      data-id="45e9d193" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2
                                          class="elementor-heading-title elementor-size-default">
                                        yifu guanjia</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-46ddab4c elementor-widget elementor-widget-heading"
                                      data-id="46ddab4c" data-element_type="widget"
                                      data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2
                                          class="elementor-heading-title elementor-size-default">
                                        医肤管家</h2>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2a4286dd elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2a4286dd" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-cadad04 elementor-widget elementor-widget-text-editor"
                                      data-id="cadad04" data-element_type="widget"
                                      data-widget_type="text-editor.default">
                                    <div class="elementor-widget-container">
                                      <p>医肤管家App，汇集了丰富的护肤知识库，为您科普日常护理知识，让您的护肤之旅更加科学、专业。</p>
                                      <p>
                                        通过深入介绍各种护肤成分，详尽解读成分功效，助您明晰其作用与适宜性，挑选出最适合您的护理方案。</p>
                                      <p>
                                        特色人工鉴图服务，仅需拍照，即刻享受专业团队的个性化分析与指导。专业识别痘痘、敏感肌等肌肤问题。</p>
                                      <p>"医肤管家", 解决用户的肌肤问题，让专业护肤服务变得简单易得。 </p>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-2f953eb elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                                      data-id="2f953eb" data-element_type="widget"
                                      data-widget_type="divider.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-divider">
																		<span class="elementor-divider-separator">
																		</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                      class="elementor-element elementor-element-93748cf elementor-widget elementor-widget-spacer"
                                      data-id="93748cf" data-element_type="widget"
                                      data-widget_type="spacer.default">
                                    <div class="elementor-widget-container">
                                      <div class="elementor-spacer">
                                        <div class="elementor-spacer-inner"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          <div class="pic-box">
                            <img class="pic-img" src="@/assets/images/pic-applet.jpg" alt>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div><!-- #mid -->

      <main-footer></main-footer>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AromoreView',
  data() {
    return {
      scrolltop: 0,

      // 点击显示弹出框
      isCodePopShow: false,
      // 点击弹出下拉框
      isDropShow: false
    }
  },
  mounted() {
    // 在组件挂载后添加监听器
    window.addEventListener('wheel', this.handleWheel);
  },
  beforeDestroy() {
    // 组件销毁前移除监听器，避免内存泄漏
    window.removeEventListener('wheel', this.handleWheel);
  },
  methods: {
    handleWheel(event) {
      // 阻止默认行为（可选，根据需要）
      // event.preventDefault();
      // 获取滚动到顶部的距离
      this.scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    },
    pathTo(url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/static/css/style.min.css";
@import "@/assets/static/css/elementor-icons.min.css";
@import "@/assets/static/css/custom-frontend.min.css";
@import "@/assets/static/css/post-12104.css";
@import "@/assets/static/css/global.css";
@import "@/assets/static/css/post-12105.css";
@import "@/assets/static/css/lightgallery.min.css";
@import "@/assets/static/css/font-awesome.min.css";
@import "@/assets/static/css/icomoon.css";
@import "@/assets/static/css/style.css";
@import "@/assets/static/css/user.css";
@import "@/assets/static/css/all.min.css";
@import "@/assets/static/css/v4-shims.min.css";
@import "@/assets/static/css/css-Raleway.css";
@import "@/assets/static/css/post-20.css";
@import "@/assets/static/css/css-SourceSansPro.css";
@import "@/assets/static/css/solid.min.css";
@import "@/assets/static/css/regular.min.css";

a {
  cursor: pointer;
}

.submenu-show {
  display: block;
}

.pic-box {
  width: 200px;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .pic-img {
    width: 100%;
  }
}

.map-img {

}

.sub-menu-img {
  width: 140px;
}

.btn-bottom-green {
  background: white;
  border-radius: 6px;
  border: 1px solid #035940;
  color: #035940;
  font-size: 18px;
  padding: 10px 30px;
  width: fit-content;
  margin: 0 0 100px;
  cursor: pointer;
  position: relative;
  left: 70%;
}

.btn-bottom-deep {
  background: #035940;
  border-radius: 6px;
  border: 1px solid #035940;
  color: #fff;
  font-size: 18px;
  padding: 10px 30px;
  width: fit-content;
  margin: 0 0 100px;
  cursor: pointer;
  position: relative;
  left: 70%;
}

/*! This file is auto-generated */
.wp-block-button__link {
  color: #fff;
  background-color: #32373c;
  border-radius: 9999px;
  box-shadow: none;
  text-decoration: none;
  padding: calc(.667em + 2px) calc(1.333em + 2px);
  font-size: 1.125em
}

.wp-block-file__button {
  background: #32373c;
  color: #fff;
  text-decoration: none
}

body {
  --wp--preset--color--black: #000000;
  --wp--preset--color--cyan-bluish-gray: #abb8c3;
  --wp--preset--color--white: #ffffff;
  --wp--preset--color--pale-pink: #f78da7;
  --wp--preset--color--vivid-red: #cf2e2e;
  --wp--preset--color--luminous-vivid-orange: #ff6900;
  --wp--preset--color--luminous-vivid-amber: #fcb900;
  --wp--preset--color--light-green-cyan: #7bdcb5;
  --wp--preset--color--vivid-green-cyan: #00d084;
  --wp--preset--color--pale-cyan-blue: #8ed1fc;
  --wp--preset--color--vivid-cyan-blue: #0693e3;
  --wp--preset--color--vivid-purple: #9b51e0;
  --wp--preset--gradient--vivid-cyan-blue-to-vivid-purple: linear-gradient(135deg, rgba(6, 147, 227, 1) 0%, rgb(155, 81, 224) 100%);
  --wp--preset--gradient--light-green-cyan-to-vivid-green-cyan: linear-gradient(135deg, rgb(122, 220, 180) 0%, rgb(0, 208, 130) 100%);
  --wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange: linear-gradient(135deg, rgba(252, 185, 0, 1) 0%, rgba(255, 105, 0, 1) 100%);
  --wp--preset--gradient--luminous-vivid-orange-to-vivid-red: linear-gradient(135deg, rgba(255, 105, 0, 1) 0%, rgb(207, 46, 46) 100%);
  --wp--preset--gradient--very-light-gray-to-cyan-bluish-gray: linear-gradient(135deg, rgb(238, 238, 238) 0%, rgb(169, 184, 195) 100%);
  --wp--preset--gradient--cool-to-warm-spectrum: linear-gradient(135deg, rgb(74, 234, 220) 0%, rgb(151, 120, 209) 20%, rgb(207, 42, 186) 40%, rgb(238, 44, 130) 60%, rgb(251, 105, 98) 80%, rgb(254, 248, 76) 100%);
  --wp--preset--gradient--blush-light-purple: linear-gradient(135deg, rgb(255, 206, 236) 0%, rgb(152, 150, 240) 100%);
  --wp--preset--gradient--blush-bordeaux: linear-gradient(135deg, rgb(254, 205, 165) 0%, rgb(254, 45, 45) 50%, rgb(107, 0, 62) 100%);
  --wp--preset--gradient--luminous-dusk: linear-gradient(135deg, rgb(255, 203, 112) 0%, rgb(199, 81, 192) 50%, rgb(65, 88, 208) 100%);
  --wp--preset--gradient--pale-ocean: linear-gradient(135deg, rgb(255, 245, 203) 0%, rgb(182, 227, 212) 50%, rgb(51, 167, 181) 100%);
  --wp--preset--gradient--electric-grass: linear-gradient(135deg, rgb(202, 248, 128) 0%, rgb(113, 206, 126) 100%);
  --wp--preset--gradient--midnight: linear-gradient(135deg, rgb(2, 3, 129) 0%, rgb(40, 116, 252) 100%);
  --wp--preset--font-size--small: 13px;
  --wp--preset--font-size--medium: 20px;
  --wp--preset--font-size--large: 36px;
  --wp--preset--font-size--x-large: 42px;
  --wp--preset--spacing--20: 0.44rem;
  --wp--preset--spacing--30: 0.67rem;
  --wp--preset--spacing--40: 1rem;
  --wp--preset--spacing--50: 1.5rem;
  --wp--preset--spacing--60: 2.25rem;
  --wp--preset--spacing--70: 3.38rem;
  --wp--preset--spacing--80: 5.06rem;
  --wp--preset--shadow--natural: 6px 6px 9px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--deep: 12px 12px 50px rgba(0, 0, 0, 0.4);
  --wp--preset--shadow--sharp: 6px 6px 0px rgba(0, 0, 0, 0.2);
  --wp--preset--shadow--outlined: 6px 6px 0px -3px rgba(255, 255, 255, 1), 6px 6px rgba(0, 0, 0, 1);
  --wp--preset--shadow--crisp: 6px 6px 0px rgba(0, 0, 0, 1);
}

:where(.is-layout-flex) {
  gap: 0.5em;
}

:where(.is-layout-grid) {
  gap: 0.5em;
}

body .is-layout-flex {
  display: flex;
}

body .is-layout-flex {
  flex-wrap: wrap;
  align-items: center;
}

body .is-layout-flex > * {
  margin: 0;
}

body .is-layout-grid {
  display: grid;
}

body .is-layout-grid > * {
  margin: 0;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

.has-black-color {
  color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-color {
  color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-color {
  color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-color {
  color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-color {
  color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-color {
  color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-color {
  color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-color {
  color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-color {
  color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-color {
  color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-color {
  color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-color {
  color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-background-color {
  background-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-background-color {
  background-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-background-color {
  background-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-background-color {
  background-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-background-color {
  background-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-background-color {
  background-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-background-color {
  background-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-background-color {
  background-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-background-color {
  background-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-background-color {
  background-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-background-color {
  background-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-black-border-color {
  border-color: var(--wp--preset--color--black) !important;
}

.has-cyan-bluish-gray-border-color {
  border-color: var(--wp--preset--color--cyan-bluish-gray) !important;
}

.has-white-border-color {
  border-color: var(--wp--preset--color--white) !important;
}

.has-pale-pink-border-color {
  border-color: var(--wp--preset--color--pale-pink) !important;
}

.has-vivid-red-border-color {
  border-color: var(--wp--preset--color--vivid-red) !important;
}

.has-luminous-vivid-orange-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-orange) !important;
}

.has-luminous-vivid-amber-border-color {
  border-color: var(--wp--preset--color--luminous-vivid-amber) !important;
}

.has-light-green-cyan-border-color {
  border-color: var(--wp--preset--color--light-green-cyan) !important;
}

.has-vivid-green-cyan-border-color {
  border-color: var(--wp--preset--color--vivid-green-cyan) !important;
}

.has-pale-cyan-blue-border-color {
  border-color: var(--wp--preset--color--pale-cyan-blue) !important;
}

.has-vivid-cyan-blue-border-color {
  border-color: var(--wp--preset--color--vivid-cyan-blue) !important;
}

.has-vivid-purple-border-color {
  border-color: var(--wp--preset--color--vivid-purple) !important;
}

.has-vivid-cyan-blue-to-vivid-purple-gradient-background {
  background: var(--wp--preset--gradient--vivid-cyan-blue-to-vivid-purple) !important;
}

.has-light-green-cyan-to-vivid-green-cyan-gradient-background {
  background: var(--wp--preset--gradient--light-green-cyan-to-vivid-green-cyan) !important;
}

.has-luminous-vivid-amber-to-luminous-vivid-orange-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-amber-to-luminous-vivid-orange) !important;
}

.has-luminous-vivid-orange-to-vivid-red-gradient-background {
  background: var(--wp--preset--gradient--luminous-vivid-orange-to-vivid-red) !important;
}

.has-very-light-gray-to-cyan-bluish-gray-gradient-background {
  background: var(--wp--preset--gradient--very-light-gray-to-cyan-bluish-gray) !important;
}

.has-cool-to-warm-spectrum-gradient-background {
  background: var(--wp--preset--gradient--cool-to-warm-spectrum) !important;
}

.has-blush-light-purple-gradient-background {
  background: var(--wp--preset--gradient--blush-light-purple) !important;
}

.has-blush-bordeaux-gradient-background {
  background: var(--wp--preset--gradient--blush-bordeaux) !important;
}

.has-luminous-dusk-gradient-background {
  background: var(--wp--preset--gradient--luminous-dusk) !important;
}

.has-pale-ocean-gradient-background {
  background: var(--wp--preset--gradient--pale-ocean) !important;
}

.has-electric-grass-gradient-background {
  background: var(--wp--preset--gradient--electric-grass) !important;
}

.has-midnight-gradient-background {
  background: var(--wp--preset--gradient--midnight) !important;
}

.has-small-font-size {
  font-size: var(--wp--preset--font-size--small) !important;
}

.has-medium-font-size {
  font-size: var(--wp--preset--font-size--medium) !important;
}

.has-large-font-size {
  font-size: var(--wp--preset--font-size--large) !important;
}

.has-x-large-font-size {
  font-size: var(--wp--preset--font-size--x-large) !important;
}

.wp-block-navigation a:where(:not(.wp-element-button)) {
  color: inherit;
}

:where(.wp-block-post-template.is-layout-flex) {
  gap: 1.25em;
}

:where(.wp-block-post-template.is-layout-grid) {
  gap: 1.25em;
}

:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

:where(.wp-block-columns.is-layout-grid) {
  gap: 2em;
}

.wp-block-pullquote {
  font-size: 1.5em;
  line-height: 1.6;
}

/*脚部调整*/
#footer.centered {
  text-align: left;
}

#footer.centered, #footer.centered .widget h3.title, #footer.centered .widget .socials {
  text-align: left;
}

.foot-items, #footer .foot-widgets {
  padding-left: 200px;
}

@media screen and (max-width: 480px) {
  .widget {
    text-align: left;
  }
  .foot-items, #footer .foot-widgets {
    padding-left: 20px;
  }
}

.foot-img {
  display: flex;
  justify-content: center;
}

#footer .widget {
  font-size: 15px;
}

/*横杠*/
.elementor-divider-separator {
  border-radius: 8px;
}

/*分类归档名称调整*/
.posts-list .title-bar.outside .page-title {
  font-size: 0;
  padding-top: 30px;
}

.posts-list .title-bar.outside .page-title span {
  font-size: 48px;
}

/*菜单间距*/
.header-horizontal .top-menu > li > a {
  padding: 0 16px;
}

/*新闻动态*/
h2.post-title {
  font-size: 1em;
  line-height: 1.4em;
}

.item-image a::before {
  background-color: #0000008c;
}

.item-image a::after {
  font-size: 0;
}

@media only screen and (max-width: 768px) {
  .bricks-frame .formatter {
    padding-left: 0;
  }
}

.bricks-frame .formatter, .post_theme_options .formatter {
  padding-top: 20px;
}

/*规则菜单*/
.widget_nav_menu ul ul {
  margin: 0 0 0 16px;
}

</style>
